// extracted by mini-css-extract-plugin
export default {"content":"UserInvitation_content__gt3nQ","title":"UserInvitation_title__5txWo"};